export default __webpack_public_path__ + "static/media/web-monitoring.32ea72e3.svg";